import React, { useEffect, useState, useCallback } from 'react';
//Queries
import tokenAdminMX from '../Queries/tokenAdminMX';
import getAdminCarritoMX from '../Queries/getAdminCarritoMX';

//Styles
import styles from './index.module.sass';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

import ExcelPNG from '../../images/sign/excel.png';

// Dependencies
import ReactExport from 'react-export-excel-fixed-xlsx';

export default function CuestionarioXVEstrellas(props) {
  const { setOptionSelected, setSectionName, getCookie } = props;
  const [valuesForm, setvaluesForm] = useState({
    noKit: '',
    fechaInicio: '',
    fechaFin: '',
  });

  const [loading, setloading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const [cuestionariosData, setCuestionariosData] = useState([]);

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  function changeValue(e, type) {
    let value = e.target.value;

    setvaluesForm({
      ...valuesForm,
      [e.target.name]: value,
    });
  }

  const getCuestionarios = useCallback(async () => {
    try {
      // Obtener el token
      const tokenResponse = await tokenAdminMX({
        tmbservice: 'WebApiLoginMX/api/login/administracion',
      });

      const {
        codigoMensaje: tokenCodigo,
        mensajeEsp: tokenMensaje,
        data: tokenData = {},
      } = tokenResponse;

      const now = new Date();
      const expireTime = now.getTime() + 1000 * 36000;
      now.setTime(expireTime);
      document.cookie = `TokenApiAdminMX=${
        tokenData.tokenLogin
      };expires=${now.toUTCString()};path=/`;

      if (tokenCodigo === 200) {
        // Obtener el cuestionario después de tener el token
        const cuestionariosResponse = await getAdminCarritoMX({
          tmbservice: 'WebApiAdminCarritoMX/api/Cuestionarios/Cuestionarios',
          jsonBody: {},
          token: tokenData.tokenLogin,
        });

        const { codigoMensaje, mensajeEsp, data } = cuestionariosResponse;

        if (codigoMensaje === 200) {
          setCuestionariosData(data.dataCuestionario);
        } else {
          alert(mensajeEsp);
        }
      } else {
        console.log(tokenMensaje, 'XV Estrellas');
      }
    } catch (error) {
      console.error('Error al obtener el token o el cuestionario:', error);
    }
  }, []);

  useEffect(() => {
    getCuestionarios();
  }, [getCuestionarios]);

  const verResultados = async (idCuestionario) => {
    if (valuesForm.noKit === '' && valuesForm.fechaInicio === '' && valuesForm.fechaFin === '') {
      alert('Necesitas llenar un campo de busqueda, numero de kit o fechas');
      return;
    }
    setloading(true);
    setOptionSelected('downloadXVEstrellas');
    setSectionName('Descargar respuestas a encuesta XV Estrellas');
    setTableData([]);

    let servicio = '';
    if (valuesForm.noKit === '') {
      servicio = `WebApiAdminCarritoMX/api/Cuestionarios/Respuestas?idCuestionario=${idCuestionario}&fechaInicio=${valuesForm.fechaInicio}&fechaFin=${valuesForm.fechaFin}`;
    } else {
      servicio = `WebApiAdminCarritoMX/api/Cuestionarios/RespuestasKit?idCuestionario=${idCuestionario}&noKit=${valuesForm.noKit}`;
    }

    const cuestionariosResponse = await getAdminCarritoMX({
      tmbservice: servicio,
      jsonBody: {},
      token: '',
      getCookie: getCookie,
    });

    const { codigoMensaje, data } = cuestionariosResponse;

    if (codigoMensaje === 200) {
      setTableData(data.respuestas);
      setvaluesForm({
        noKit: '',
        fechaInicio: '',
        fechaFin: '',
      });
    } else {
      alert('Error, intentalo nuevamente');
    }
    setloading(false);
  };

  return (
    <div className={styles.form}>
      <div className={styles.cabeceroCuestionario}>
        <div className={styles.tableCabecero}>
          <div className={styles.titleCuestionario}>
            Selecciona el tipo de cuestionario que quieres descargar:
          </div>
          <div className={styles.th}>
            <div className={styles.row}>Nombre cuestionario</div>
            <div className={styles.rowCenter}>Opciones de descarga</div>
          </div>

          {cuestionariosData.map((data, index) => {
            return (
              <div className={styles.td} key={index}>
                <div className={styles.row}>{data.cuestionario}</div>

                <div className={styles.rowCenter}>
                  <div className={styles.miniTable}>
                    <div className={styles.gapMiniTable}>Kit:</div>
                    <div className={styles.gapMiniTable}>
                      <input
                        type='text'
                        placeholder='Por número de kit'
                        className={styles.inputText}
                        name='noKit'
                        value={valuesForm.noKit || ''}
                        onChange={(e) => changeValue(e)}
                      />
                    </div>
                    <div className={styles.gapMiniTable}>Ó / </div>
                    <div className={styles.gapMiniTable}>Del:</div>
                    <div className={styles.gapMiniTable}>
                      <input
                        type='date'
                        className={styles.inputText}
                        name='fechaInicio'
                        value={valuesForm.fechaInicio || ''}
                        onChange={(e) => changeValue(e)}
                      />
                    </div>
                    <div className={styles.gapMiniTable}>al</div>
                    <div className={styles.gapMiniTable}>
                      <input
                        type='date'
                        className={styles.inputText}
                        name='fechaFin'
                        value={valuesForm.fechaFin || ''}
                        onChange={(e) => changeValue(e)}
                      />
                    </div>
                    <div
                      className={styles.gapMiniTable}
                      onClick={() => {
                        verResultados(data.id);
                      }}>
                      <span className={`material-icons`} style={{ fontSize: '24px' }}>
                        search
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {tableData.length > 0 && (
        <>
          <div className={styles.divButton}>
            <ExcelFile
              element={
                <Button
                  type='button'
                  variant='contained'
                  size='large'
                  color='primary'
                  className={styles.button}>
                  <img src={ExcelPNG} alt='excel' className={styles.imgIcone} />
                  &nbsp;Descargar
                </Button>
              }
              filename='EncuestasXVEstrellas'>
              <ExcelSheet data={tableData} name='XVEstrellas'>
                <ExcelColumn label='NoKit' value='noKit' />
                <ExcelColumn label='Nombre' value='nombre' />
                <ExcelColumn label='Pregunta' value='pregunta' />
                <ExcelColumn label='Respuesta' value='respuesta' />
                <ExcelColumn label='Opcion' value='opcion' />
              </ExcelSheet>
            </ExcelFile>
          </div>
          <div className={styles.tableData}>
            <div className={styles.thData}>
              <div className={styles.row}>Número de kit</div>
              <div className={styles.row}>Nombre</div>
              <div className={styles.row}>Pregunta</div>
              <div className={styles.row}>Respuesta</div>
              <div className={styles.row}>Opcion</div>
            </div>
            {!loading ? (
              <>
                {tableData.map((values, key) => {
                  return (
                    <div className={styles.td} key={key}>
                      <div className={styles.row}>{values.noKit}</div>
                      <div className={styles.row}>{values.nombre}</div>
                      <div className={styles.row}>{values.pregunta}</div>
                      <div className={styles.row}>{values.respuesta}</div>
                      <div className={styles.row}>{values.opcion}</div>
                    </div>
                  );
                })}
              </>
            ) : (
              <div className={styles.divLoading}>
                <CircularProgress className={styles.circular} />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
